import React from 'react';
import { Modal, Form } from 'antd';

import type { Contact } from '../../types/common';
import type { TFunction } from 'i18next';
import ContactsFormSection from '../common/ContactsFormSection';

interface ContactEditModalProps {
  open: boolean;
  contact?: Contact;
  onCancel: () => void;
  onSave: (contacts: Contact[]) => void;
  contactTypeOptions: { value: string; label: string; }[];
  t: TFunction;
}

const ContactEditModal: React.FC<ContactEditModalProps> = ({
  open,
  contact,
  onCancel,
  onSave,

  t,
}) => {
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSave(values.contacts);
    } catch (error) {
      // Form validation failed
    }
  };

  return (
    <Modal
      title={contact ? t('common:editContact') : t('common:addContact')}
      open={open}
      onCancel={onCancel}
      onOk={handleSubmit}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={contact ? { contacts: [contact] } : undefined}
      >
        <ContactsFormSection
          t={t}

        />
      </Form>
    </Modal>
  );
};

export default ContactEditModal; 